<nz-spin [nzSpinning]="loading">
    <nz-timeline>
        <nz-timeline-item>
            <h3>Noskenējiet TOTP iestatīšanas QR kodu</h3>
            <p>
                Skenerējiet šo QR kodu ar savu autentifikatora lietotni (piem. Microsoft Authenticator vai Google Authenticator), lai iestatītu TOTP
                divu faktoru autentifikāciju.
            </p>
            @if (totpSetupQrCodeBase64) {
                <img class="qr-code" nz-image [nzSrc]="'data:image/png;base64,' + totpSetupQrCodeBase64" nzAlt="TOTP Setup QR Code" />
            }
        </nz-timeline-item>
        <nz-timeline-item>
            <h3>Ievadiet TOTP kodu no jūsu autentifikatora lietotnes</h3>
            <div class="row gap-2">
                <input nz-input placeholder="TOTP kods" [(ngModel)]="totpCode" (keyup.enter)="submitTOTP()" />
                <button nz-button [disabled]="!totpCode" nzType="default" (click)="submitTOTP()">Apstiprināt</button>
            </div>
        </nz-timeline-item>
    </nz-timeline>
</nz-spin>
@if (transitionMode && totpIgnoresLeft > 0) {
    <p class="m-0">Jūs varat izlaist TOTP iestatīšanu vēl {{ totpIgnoresLeft }} {{ totpIgnoresLeft === 1 ? 'reizi' : 'reizes' }}</p>
} @else if (transitionMode && totpIgnoresLeft === 0) {
    <p class="m-0">Jūs vairs nevarat izlaist TOTP iestatīšanu. Lūdzu veiciet iestatīšanu tagad!</p>
}

<div *nzModalFooter class="modal-footer">
    <div class="modal-footer-right">
        @if (transitionMode && totpIgnoresLeft > 0) {
            <button nz-button nzType="primary" (click)="dismiss()">Izlaist</button>
        }
    </div>
    <div class="modal-footer-left">
        @if (transitionMode) {
            <button nz-button nzType="default" (click)="logout()">Izlogoties</button>
        }
    </div>
</div>
